module.exports = __webpack_public_path__ + "static/media/19-4.de3c2149.mp3";